import axios from "axios";

// const
const MODULE_ADD_STORE_MODULE_DATA = "moduleAdd/MODULE_ADD_STORE_MODULE_DATA";
const MODULE_ADD_UPDATE_DATA = "moduleAdd/MODULE_ADD_UPDATE_DATA";
const MODULE_ADD_STORE_APPLICATION_TERMINALS = "moduleAdd/MODULE_ADD_STORE_APPLICATION_TERMINALS";
const MODULE_ADD_STORE_APPLICATION_MODELS = "moduleAdd/MODULE_ADD_STORE_APPLICATION_MODELS";
const MODULE_ADD_STORE_APPLICATION_TYPES = "moduleAdd/MODULE_ADD_STORE_APPLICATION_TYPES";
const MODULE_ADD_STORE_APPLICATION_CATEGORY_TREE = "moduleAdd/MODULE_ADD_STORE_APPLICATION_CATEGORY_TREE";
const MODULE_ADD_TOGGLE_MODAL = "moduleAdd/MODULE_ADD_TOGGLE_MODAL";
const MODULE_ADD_TOGGLE_LOADING = "moduleAdd/MODULE_ADD_TOGGLE_LOADING";

// modal const
const MODULE_ADD_MODAL_SUCCESS_TITLE = "scenes_Application_ModuleAdd_modal_success_title";
const MODULE_ADD_MODAL_FAIL_TITLE = "scenes_Application_ModuleAdd_modal_fail_title";
const MODULE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Application_ModuleAdd_modal_submitSuccess_content";
const MODULE_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Application_ModuleAdd_modal_submitFail_content";
const MODULE_ADD_MODAL_UPLOAD_FILE_SUCCESS_CONTENT = "scenes_Application_ModuleAdd_modal_uploadFileSuccess_content";
const MODULE_ADD_MODAL_UPLOAD_FILE_FAIL_CONTENT = "scenes_Application_ModuleAdd_modal_uploadFileFail_content";  //，是否重新上传？
const MODULE_ADD_MODAL_OK_LABEL = "scenes_Application_ModuleAdd_modal_OK_label";
const MODULE_ADD_MODAL_CANCEL_LABEL = "scenes_Application_ModuleAdd_modal_cancel_label";
const MODULE_ADD_MODAL_JUMP_LABEL = "scenes_Application_ModuleAdd_modal_jump_label";
const MODULE_ADD_MODAL_RETURN_LABEL = "scenes_Application_ModuleAdd_modal_return_label";
const MODULE_ADD_MODAL_YES_LABEL = "scenes_Application_ModuleAdd_modal_yes_label";
const MODULE_ADD_MODAL_NO_LABEL = "scenes_Application_ModuleAdd_modal_no_label";

// reducer
export const moduleAdd = (state = {
  loading: false,
  flag: "",
  applicationId: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  visibleLogo: false,
  previewLogo: "",
  logoImage: [],
  logo: "",

  mainApplication: [],
}, action) => {
  switch (action.type) {
    case MODULE_ADD_STORE_MODULE_DATA:
      return {
        ...state,
        applicationId: action.data.id,
        mainApplication: action.data,
        modalVisible: false,
        visibleLogo: false,
        previewLogo: "",
        logoImage: [],
        logo: "",
      };
    case MODULE_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MODULE_ADD_STORE_APPLICATION_TERMINALS:
      return {
        ...state,
        applicationTerminals: action.data
      };
    case MODULE_ADD_STORE_APPLICATION_MODELS:
      return {
        ...state,
        applicationModels: action.data
      };
    case MODULE_ADD_STORE_APPLICATION_TYPES:
      return {
        ...state,
        applicationTypes: action.data
      };
    case MODULE_ADD_STORE_APPLICATION_CATEGORY_TREE:
      return {
        ...state,
        applicationCategoryTree: action.data
      };
    case MODULE_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case MODULE_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateModuleData = (data) => {
  return {
    type: MODULE_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * initial data on load
 */
export const initialModulePage = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  dispatch(updateModuleData({
    name: "flag",
    value: data.flag
  }));
  axios.get(`/api-application/getApplication/${data.application}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeModuleData(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store Module Data
 */
export const storeModuleData = (mainApplication) => {
  return {
    type: MODULE_ADD_STORE_MODULE_DATA,
    data: mainApplication
  }
};

/**
 * submit data
 */
export const submitModule = (data, history, flag) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "post",
    url: "/api-application/submitApplication",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "code": data.code,
      "name": data.name,
      "enName": data.enName,
      "logo": data.logo,
      "terminal": data.application.terminal,
      "model": data.application.model,
      "type": data.application.type,
      "parentCategory": data.application.parentCategory,
      "category": data.application.category,
      "status": {"code": data.status},
      "description": data.description,
      "createUserId": data.createUserId,
      "createUserName": data.createUserName,
      "createCompanyId": data.createCompanyId,
      "createCompanyName": data.createCompanyName,
      "mainApplication": {"id": data.application.id},
      "ifModule": true,
      "ifEnabled": true
    },
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success create new module");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_ADD_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: MODULE_ADD_MODAL_JUMP_LABEL,
          modalCancel: MODULE_ADD_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            history.push(`/console/application-edit?id=${data.applicationId}&flag=${flag}`);
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            history.push(`/console/application-edit?id=${data.applicationId}&flag=${flag}`);
          }
        }));
      } else {
        console.error("fail to create new module");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_ADD_MODAL_FAIL_TITLE,
          modalContent: MODULE_ADD_MODAL_SUBMIT_FAIL_CONTENT,
          modalOk: MODULE_ADD_MODAL_OK_LABEL,
          modalCancel: MODULE_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: MODULE_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MODULE_ADD_TOGGLE_LOADING,
    data: show
  }
};
